/*@ngInject*/
const CollaborationUpdateTaskRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.updateCollaborationTask = function (taskId, data) {
        let url = '/rest/SubmissionTask/' + taskId;

        return this.post(url, data);
    };

    this.updateCollaborationTaskAttachment = function (taskId, data) {
        var url = '/rest/SubmissionTask/' + taskId + '/Attachment';

        return this.post(url, data);
    };
};

angular.module('gw-um-submission')
    .service('collaborationUpdateTaskRepository', CollaborationUpdateTaskRepository);
